module.exports = "https://cdn.hellotech.com/client-assets/smart-home-desktop_80714680e58d8956de8430b00289ec8f.jpg";